import React from "react";
import { motion } from "framer-motion";

const TICKER_ITEMS = [
  { s: "RELIANCE", c: +1.24 }, { s: "HDFCBANK", c: -0.32 }, { s: "DATAPATTNS", c: +3.91 },
  { s: "GLENMARK", c: +4.24 }, { s: "TCS", c: +0.56 }, { s: "WELCORP", c: +2.12 },
  { s: "DRREDDY", c: +9.37 }, { s: "NIFTYBANK", c: -1.04 }, { s: "TVSMOTOR", c: -4.03 },
  { s: "CIPLA", c: +5.63 }, { s: "PPLPHARMA", c: +6.54 }, { s: "ASIANPAINT", c: -0.18 },
  { s: "BAJAJFINSV", c: +1.12 }, { s: "ITC", c: +0.22 }, { s: "ADANIENT", c: -2.16 },
  { s: "LT", c: +0.88 },
];

export default function AuthTicker() {
  const row = (
    <div className="flex items-center gap-8 whitespace-nowrap">
      {TICKER_ITEMS.map((t) => (
        <div key={t.s} className="flex items-center gap-2 font-mono text-xs">
          <span className="text-primary-fg/90 tracking-wider">{t.s}</span>
          <span className={t.c >= 0 ? "text-pos" : "text-neg"}>
            {t.c > 0 ? "+" : ""}{t.c.toFixed(2)}%
          </span>
          <span className="text-muted-fg">·</span>
        </div>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden relative py-2 border-y border-subtle bg-app/70">
      <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-[hsl(var(--bg))] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-[hsl(var(--bg))] to-transparent z-10 pointer-events-none" />
      <motion.div
        className="flex gap-8"
        animate={{ x: [0, -1200] }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
      >
        {row}
        {row}
      </motion.div>
    </div>
  );
}
